import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\TaskDossier\UpdateTaskDossierController::__invoke
* @see app/Http/Controllers/TaskDossier/UpdateTaskDossierController.php
* @route '/api/task-dossier/{task_dossier}'
*/
const UpdateTaskDossierController = (args: { task_dossier: string | number | { id: string | number } } | [task_dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: UpdateTaskDossierController.url(args, options),
    method: 'put',
})

UpdateTaskDossierController.definition = {
    methods: ["put"],
    url: '/api/task-dossier/{task_dossier}',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\TaskDossier\UpdateTaskDossierController::__invoke
* @see app/Http/Controllers/TaskDossier/UpdateTaskDossierController.php
* @route '/api/task-dossier/{task_dossier}'
*/
UpdateTaskDossierController.url = (args: { task_dossier: string | number | { id: string | number } } | [task_dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { task_dossier: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { task_dossier: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            task_dossier: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        task_dossier: typeof args.task_dossier === 'object'
        ? args.task_dossier.id
        : args.task_dossier,
    }

    return UpdateTaskDossierController.definition.url
            .replace('{task_dossier}', parsedArgs.task_dossier.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\TaskDossier\UpdateTaskDossierController::__invoke
* @see app/Http/Controllers/TaskDossier/UpdateTaskDossierController.php
* @route '/api/task-dossier/{task_dossier}'
*/
UpdateTaskDossierController.put = (args: { task_dossier: string | number | { id: string | number } } | [task_dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: UpdateTaskDossierController.url(args, options),
    method: 'put',
})

export default UpdateTaskDossierController